import React from 'react';
import PropTypes from 'prop-types';

import Tag from 'eventbrite_design_system/tag/Tag';
import SelectField from 'eventbrite_design_system/inputField/SelectField';
import {VALUES_PROP_TYPE} from 'eventbrite_design_system/inputField/constants';

import {TAG_BACKGROUND_COLOR} from '../constants';
import './dropdownTag.scss';

const SELECT_FIELD_STYLE = 'basic';

export default class DropdownTag extends React.PureComponent {
    static propTypes = {
        id: PropTypes.string,
        displayValue: PropTypes.string,
        values: VALUES_PROP_TYPE,
        placeholder: PropTypes.string,
        label: PropTypes.string,
        shouldKeepStyle: PropTypes.bool,
        onChange: PropTypes.func,
        onClose: PropTypes.func,
        isLoading: PropTypes.bool,
    }

    static defaultProps = {
        shouldKeepStyle: false,
    }

    render() {
        const {
            placeholder,
            id,
            label,
            values,
            displayValue,
            shouldKeepStyle,
            onChange,
            onClose,
            isLoading,
        } = this.props;

        let Component = SelectField;

        let PROP_MAP = {
            placeholder,
            id,
            label,
            values,
            onChange,
            value: displayValue,
            style: SELECT_FIELD_STYLE,
            disabled: isLoading,
        };

        if (displayValue && !shouldKeepStyle) {
            Component = Tag;

            const children = displayValue;

            PROP_MAP = {
                children,
                isStatic: true,
                backgroundColor: TAG_BACKGROUND_COLOR,
                isClosable: true,
                onClose,
            };
        }

        return (
            <span className="dropdown-tag">
                <Component {...PROP_MAP} />
            </span>
        );
    }
}
